export enum ReferenceName {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  USER_INFO = 'user_info',
  TASK_TIMER = 'timer_start_time',
  TASK_DETAIL = 'task_detail',
  IsLogConfirmationDialogShow = 'is_log_confirm_dialog_show',
  PERMISSIONS = 'permissions'
}
